import React from 'react';
import { Link } from 'react-router-dom';
import { FEATURE_SLUGS } from '../pages/FeaturePage';

const FEATURE_LABELS = {
  'adaptive-training': 'Adaptive training',
  'nutrition': 'AI meal planning',
  'food-snap': 'AI food snap',
  'injury-adaptive': 'Injury-adaptive workouts',
  'progression': 'Progression tracking',
  'ai-coach': 'AI coach',
  'consistency': 'Shōjin Dō · Consistency',
};

const Footer = () => (
  <footer className="bg-[#0b0b0c] border-t border-[color:var(--fff-glass-border)] py-12">
    <div className="max-w-[1180px] mx-auto px-5 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-left">
        <div>
          <div className="flex items-center gap-2">
            <span
              className="text-white font-black tracking-tight text-2xl"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Free<span className="text-[#BEFF38]">Fit</span>Fuel
            </span>
          </div>
          <p className="mt-3 text-sm text-zinc-400 max-w-xs leading-relaxed">
            The AI fitness tutor that adapts as your body does.
          </p>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-[0.22em] font-black text-[#BEFF38]">Features</p>
          <ul className="mt-3 space-y-2">
            {FEATURE_SLUGS.map((slug) => (
              <li key={slug}>
                <Link
                  to={`/features/${slug}`}
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                  data-testid={`footer-feature-${slug}`}
                >
                  {FEATURE_LABELS[slug]}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/features"
                className="text-sm font-semibold text-[#BEFF38] hover:text-[#a8e62e]"
                data-testid="footer-features-index"
              >
                All features →
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-[0.22em] font-black text-[#BEFF38]">Company</p>
          <ul className="mt-3 space-y-2">
            <li><Link to="/how-it-works" className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid="footer-how-it-works-link">How it works</Link></li>
            <li><Link to="/privacy" className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><a href="mailto:gcanth@gmail.com" className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid="footer-contact-link">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-zinc-800 text-center">
        <p className="text-zinc-500 text-xs">© 2025–2026 FreeFitFuel™ · All rights reserved.</p>
        <p className="mt-1 text-zinc-400 font-semibold text-xs">Created by Grant Cameron Anthony</p>
      </div>
    </div>
  </footer>
);

export default Footer;
